// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const DeleteXList: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="9" viewBox="0 0 8 9">
            <path
                fill="currentColor"
                d="M7.279688,6.22089815 C7.57265675,6.5138669 7.57265675,6.98847628 7.279688,7.28144503 C7.13437521,7.4279294 6.94218814,7.50058579 6.75000036,7.50058579 C6.55781257,7.50058579 6.36609399,7.42734361 6.21984422,7.28085923 L3.75000036,4.81230426 L1.2803911,7.28027344 C1.13390672,7.4279294 0.94195354,7.50058579 0.750000358,7.50058579 C0.558047175,7.50058579 0.366328239,7.4279294 0.219726562,7.28027344 C-0.0732421875,6.98730469 -0.0732421875,6.51269531 0.219726562,6.21972656 L2.69003928,3.74941421 L0.219726562,1.28027344 C-0.0732421875,0.987304687 -0.0732421875,0.512695312 0.219726562,0.219726562 C0.512695312,-0.0732421875 0.987304687,-0.0732421875 1.28027344,0.219726562 L3.75,2.69121087 L6.22031236,0.220898151 C6.51328111,-0.0720705986 6.98789048,-0.0720705986 7.28085923,0.220898151 C7.57382798,0.513866901 7.57382798,0.988476276 7.28085923,1.28144503 L4.81054687,3.75175738 L7.27968764,6.22089815 L7.279688,6.22089815 Z"
                transform="translate(0 .75)"
            />
        </svg>
    );
};

export default React.memo(DeleteXList);
